<template>
  <section>
    <div class="fileBoxStep2">
      <div class="fileBoxStep2-title">
        {{ obj.title }}
      </div>
      <div class="fileBoxStep2-date">
        2019-10-29 来源：河南省教育厅
      </div>
      <div class="fileBoxStep2-content">
        <el-table
          :data="obj.content"
          stripe
          border
          :header-cell-style="tableHead"
        >
          <el-table-column label="部类" align="center">
            <el-table-column
              prop="category"
              label="五大部类"
              align="center"
              width="200"
            />
            <el-table-column prop="" label="22个基本部类" align="center">
              <template slot-scope="scope">
                <div
                  v-for="(item, index) in scope.row.basic"
                  :key="index"
                  :style="multistepStyle(index, scope.row.basic.length)"
                >
                  {{ item }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="分类比例" align="center">
            <el-table-column
              prop="primary"
              label="小学"
              align="center"
              width="200"
            />
            <el-table-column
              prop="middle"
              label="中学"
              align="center"
              width="200"
            />
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComStep2',
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableHead: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {
    multistepStyle(v, x) {
      if (x > 1) {
        if (v == 0) {
          return {
            paddingBottom: '12px'
          }
        } else if (v + 1 == x) {
          return {
            borderTop: '1px solid #EBEEF5',
            paddingTop: '12px'
          }
        } else {
          return {
            borderTop: '1px solid #EBEEF5',
            padding: '12px 0'
          }
        }
      } else {
        return null
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.fileBoxStep2 {
  height: 100%;
  padding: 20px;
  &-title {
    height: 60px;
    font-size: 26px;
    text-align: center;
    margin-top: 20px;
    color: #333;
    font-weight: bold;
    font-family: "Microsoft YaHei";
  }
  &-date {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding-bottom: 20px;
    font-family: "Microsoft YaHei";
  }
  &-content {
    line-height: 36px;
    @include fun-design(1);
    color: #333;
    font-size: 16px;
    font-family: "Microsoft YaHei";
  }
}
</style>
